var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwsSes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 299",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60.556 47.602-60.556 96.408 60.556 96.424 1.056-.753-.775-191.881z",
    fill: "#876929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m128.187 223.105-67.631 17.329v-192.832l67.631 17.325z",
    fill: "#d9a741"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m255.979 71.868-32.6 5.391-74.841-77.259-37.207 16.292 4.908 9.153-26.333 10.526v243.428l38.28 19.153.637-.499-.589-250.235 81.142 122.968z",
    fill: "#876929"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9a741"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m148.538 0 99.679 49.837-39.417 71.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.975 71.868.025 162.728-127.813 63.956-.017-277.869 80.63 146.291z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsSes);
export default __webpack_public_path__ + "static/media/aws-ses.c1b08e60aa4d99ca6da5ac1a101df654.svg";
export { ForwardRef as ReactComponent };